import {ApolloError} from '@apollo/client';
import { useCallback } from 'react';
import {UseFormSetError} from 'react-hook-form';

//Utils
import {parseResponseErrors} from '~utils/formHelpers';
//Hooks
import {useCommonModals} from '~context/commonModals';
import {IReporterCaptureExceptionParams} from '~utils/remoteReportHelper';



function useOnGraphQLError<TFieldValues>() {
    const {openErrorModal} = useCommonModals();

    const handleGraphQLError = useCallback((setError?: UseFormSetError<TFieldValues>) => (err: ApolloError) => {
        if (err?.name === 'AbortError' || err?.networkError?.name === 'AbortError') {
            // eslint-disable-next-line no-console
            console.log('User Aborted the request');
            return;
        }
        const formErrors = parseResponseErrors(err);

        const reportData: IReporterCaptureExceptionParams = {
            error: err,
            errorScope: 'handleGraphQLError',
            extraData: {
                extra: err,
                tags: {
                    'apollo_error_code': formErrors.code,
                    'apollo_path': err?.graphQLErrors?.map(desc => desc?.path).toString()
                }
            }
        };

        if (formErrors.code === 'GRAPHQL_VALIDATION_FAILED') {
            const firstErrorField: any = Object.keys(formErrors.errors)?.[0];
            const firstErrorMessage = formErrors.errors?.[firstErrorField]?.[0];
            if (firstErrorField && firstErrorMessage && setError) {
                return setError(firstErrorField, {type: 'manual', message: firstErrorMessage});
            } else {
                openErrorModal({reportData});
            }
        } else if (formErrors.code === 'UNKNOWN_CODE') {
            openErrorModal({reportData: err.networkError ? undefined : reportData});
        } else if (formErrors.code === 'FORBIDDEN') {
            const errorMessage = err?.graphQLErrors?.[0]?.message ?? 'You don\'t have permission to access this resource';

            openErrorModal({modalBody: errorMessage});
        } else {
            openErrorModal({reportData});
        }
    }, [openErrorModal]);

    return handleGraphQLError;
}

export default useOnGraphQLError;
